import React from 'react';

import { Section } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

import { FieldRequirement } from './FieldRequirement';
import { InputOptions } from './InputOptions';
import { LabelText } from './LabelText';
import { LabelVisibility } from './LabelVisibility';
import { PlaceholderText } from './PlaceholderText';

interface Props {
  nodeIds: string[];
}

export const SelectInputToolbox = React.memo(({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds, (node) => ({
    props: node?.data.props || {},
  }));

  return (
    <Section name="Select Input Settings">
      <LabelText setProps={setProps} label={props.label} inputNamePrefix="select-input" />
      <PlaceholderText
        setProps={setProps}
        placeholder={props.placeholder}
        inputNamePrefix="select-input"
      />
      <LabelVisibility
        showLabel={props.showLabel}
        setProps={setProps}
        inputNamePrefix="select-input"
      />
      <FieldRequirement
        setProps={setProps}
        inputNamePrefix="select-input"
        validation={props.validation}
        label={props.label}
      />
      <InputOptions inputOptions={props.options} setProps={setProps} />
    </Section>
  );
});
